// extracted by css-extract-rspack-plugin
export default {"inlineCaption":"InlineCaption_inlineCaption__WKvz5"};